import { Observable, of, map, catchError } from 'rxjs';
import { ComponentPermissionService, PermissionFunction } from '../component-permission.service';

export function canViewEvent(service: ComponentPermissionService): PermissionFunction {
  return {
    name: 'Can View Event',
    description: 'Check if user can view a specific event (based on participation, instructor status, or admin role)',
    requiresContext: true,
    execute: (context?: any) => {
      
      // If no event ID provided, deny access
      if (!context?.eventId) {
        return of(false);
      }

      // Get current user
      const currentUser = service.authService.getCurrentUser();
      if (!currentUser) {
        return of(false);
      }

      // Check if user has admin roles (can view any event)
      const adminRoles = ['superadmin', 'orgadmin', 'uddansvarlig', 'uddassistent'];
      if (currentUser.roles && currentUser.roles.some((role: string) => adminRoles.includes(role))) {
        return of(true);
      }

      // Check if user is a participant or instructor for this event
      const eventId = context.eventId;
      return service.http.get(`${service.apiUrl}/events/${eventId}/participants`).pipe(
        map((participants: any) => {
          
          if (Array.isArray(participants)) {
            const isParticipant = participants.some(participant => 
              participant.id === currentUser.id || 
              participant.user_id === currentUser.id ||
              participant.uuid === currentUser.uuid
            );
            return isParticipant;
          }
          
          return false;
        }),
        catchError(error => {
          console.error('[canViewEvent] Error checking event participants:', error);
          // Also check if user is an instructor as fallback
          return service.http.get(`${service.apiUrl}/events/${eventId}/instructors`).pipe(
            map((instructors: any) => {
              if (Array.isArray(instructors)) {
                const isInstructor = instructors.some(instructor => 
                  instructor.id === currentUser.id || 
                  instructor.user_id === currentUser.id ||
                  instructor.uuid === currentUser.uuid
                );
                return isInstructor;
              }
              return false;
            }),
            catchError(() => of(false))
          );
        })
      );
    }
  };
} 